import React from "react";
import { useState, useEffect, useRef } from "react";
import { useCallback } from "react";
import { io } from "socket.io-client";
import mcDonaldsLogo from '../../asses/not-found/logo-removebg-preview.png'
import Tables from "./Tables";
import Register from "./Register";
import imgLogo from './../../asses/not-found/logo-removebg-preview.png'
import soundBoxMoney from './../../sounds/Cash_Register_Kashing_-_Sound_Effect_[_YouConvert.net_].mp3'
import soundCampaignMoney from './../../sounds/Campana_de_servicio_-_Efecto_de_sonido_HD_[_YouConvert.net_].mp3'
import Error from "../Error";
import imgForHome from '../../asses/not-found/logo-home-removebg-preview.png'
import chatSound from './../../sounds/Outlook notification sound.mp3'
import jsPDF from "jspdf";

function Admin8({api8,centralApi, securityAdmin, setConsoleAdmin, consoleAdmin, setVisibilityClientFrontend }) {
  const [freeVersion, setFreeVersion] = useState(true)
  const [receiveOrders, setReceiveOrders] = useState([]);
  const messagesEndRef = useRef(null);
  const socketRef = useRef();
  const [visibilityOrder, setVisibilityOrder] = useState(false)
  const [visibilityProductsOrder, setVisibilityProductsOrder] = useState(false)
  const [sendDataState, setSendDataState] = useState()
  const [error, setError] = useState("Base de datos offline")
  const [dataOrders, setDataOrders] = useState([])
  const [newFetch, setNewFetch] = useState(0)
  const [listActive, setListActive] = useState(false)
  const [orderIdCounter, setOrderIdCounter] = useState(1); // Contador para nuevos IDs
  const [payOfDay, setPayOfDay] = useState(0)
  const [totalDayObject, setTotalDayObject] = useState({ date: "", data: "", totalPay: 0 })

  // VISIBILITYS

  const [homeVisibility, setHomeVisibility] = useState(true)
  const [tablesVisibility, setTablesVisibility] = useState(false)
  const [chatVisibility, setChatVisibility] = useState(false)
  const [registerVisibility, setRegisterVisibility] = useState(false)
  const [visibilityPayOfDay, setVisibilityPayOfDay] = useState(false)

  const [mensajes, setMensajes] = useState([]);

  const [completedOrders, setCompletedOrders] = useState(new Set());
  const [orderVisibility, setOrderVisibility] = useState({});

  const [dataShow, setDataShow] = useState()

  // ESTADOS CONTABILZIADORES FUNCIONALES

  const [newOrderInProcess, setNewOrderInProcess] = useState(0)
  const [newMessageChat, setNewMessageChat] = useState(0)

  const [newRequestWish, setNewRequestWish] = useState({ table1: 0, table2: 0, table3: 0, table4: 0, table5: 0, table6: 0, table7: 0, table8: 0, table9: 0 })

  // asignar ID

  // contador global para generar IDs únicos
  const generateUniqueId = () => {
    const currentId = orderIdCounter; // Guarda el ID actual
    setOrderIdCounter(prevId => prevId + 1); // Incrementa el contador
    return currentId; // Devuelve el ID actual
  };

// eliminar un pedido de la bd
const [message,setMessage] = useState("")

const handleDelete = async (id) => {
   try {
     const response = 
     await fetch(api8, 
      { method: 'DELETE', headers: { 'Content-Type': 'application/json', },
       body: JSON.stringify({ id: id }), }); 
       const data = await response.json(); if (response.ok)
       
         { setNewFetch(newFetch + 1)
           setMessage(`Registro eliminado correctamente: ${JSON.stringify(data)}`); }
        else { setMessage(`Error: ${data.error}`); } }
      catch (error) { setMessage(`Error al eliminar el registro: ${error.message}`); } 
    };


  // MAPEANDO BASE DE DATOS
   const functionMapeoBaseDeDatos = () => {
    return(
    <div className="functionmapeobd">
      <p>Deseas tener su propio registro y contar con beneficios adicionales?</p>
      <p>Solicita una mejora de tu version</p>
      <button className="secundary-button"><a href="https://cookeronconnection.github.io">Aqui</a></button>
  
  </div>
  )

};

// ORDEN COMPLETADA
 socketRef.current = io(api8, {
      path: "/socket",
      transports: ['websocket', 'polling'],
    });
  
const sendPetition = (table) => {
  // Intentar ejecutar el código dentro del evento
  try {
    // Capturar el evento 'pedidoEnviado'
    socketRef.current.emit("pedidoEnviado", table)
 
      // Aquí puedes agregar más lógica según sea necesario);

    console.log("Se envió el pedido desde el EMISOR");
  } catch (error) {
    console.error("Error al recibir el evento 'pedidoEnviado':", error);
  }
};

  const completeOrder = (id, table) => {
    setConsoleAdmin(prevState => [...prevState, `Completar orden con ID: ${id}`]);
  // Verifica que el ID sea válido
  sendPetition(table)
    if (id == null || id === 0) {
      setConsoleAdmin(prevState => [...prevState,'ID no válido:', id]);
      return; // Salir si el ID es inválido
    }

    // Actualiza el estado de órdenes completadas
    setCompletedOrders(prev => {
      const newCompletedOrders = new Set(prev);

      // Verifica si la orden ya está completada
      if (newCompletedOrders.has(id)) {
        newCompletedOrders.delete(id); // Marca como no completada

        setConsoleAdmin(prevState => [...prevState,`Orden ${id} marcada como no completada.`]);
      } else {
        newCompletedOrders.add(id); // Marca como completada
        // console.log(`Orden ${id} marcada como completada.`);
      }

      return newCompletedOrders; // Devuelve el nuevo Set
    });

  };
  // Actualiza el estado de órdenes completadas

  // Función para marcar una orden como completada
  const completeState = (id) => {
    if (id == null || id === 0) {
      console.error('ID no válido:', id);
      return; // Salir si el ID es inválido
    }

    setCompletedOrders(prev => {
      const newCompletedOrders = new Set(prev);

      if (newCompletedOrders.has(id)) {
        newCompletedOrders.delete(id);
        setConsoleAdmin(prevState => [...prevState,`Orden ${id} marcada como no completada.`]);
      } else {
        newCompletedOrders.add(id);
        setConsoleAdmin(prevState => [...prevState,`Orden ${id} marcada como completada.`]);
      }

      return newCompletedOrders; // Devuelve el nuevo Set
    });
  };


 

  // sumando valores del dia
  const paySum = () => {
    const sumOrders = dataOrders.reduce((data, index) => {
      return data + index.totalPayOrder
    }, 0)

    setPayOfDay(sumOrders)
    setVisibilityPayOfDay(true)


  }


  useEffect(() => {
    paySum()
    setTimeout(() => setConsoleAdmin(prevState => [...prevState,"este es el total del dia: " + payOfDay]), 1000)
  }, [dataOrders])


  useEffect(() => {
    setVisibilityClientFrontend(false)
  }, [])

  // logica visibilidades pedidos

  const functionVisibilityOrder = (e) => {
    e.preventDefault()
    setVisibilityOrder(!visibilityOrder)
  }
  // Logica coneccion backend PEDIDOS DESDE EL CLIENTE ALA COCINA
  // const apiSendMessage = api1;

  const generateUniqueId2 = () => {
    const timestamp = new Date().getTime(); // Obtiene el timestamp actual en milisegundos
    const randomNum = Math.floor(Math.random() * 1000); // Genera un número aleatorio de 3 dígitos
    return `${timestamp}-${randomNum}`; // Une ambos para formar el ID
  };
  
  
  const processedOrderDates = new Map();

const handlePedidoALaCocina = (data) => {
  try {
    const orderWithId = { ...data, id: generateUniqueId2() };

    // Accedemos a la fecha del primer producto en el array `products`
    const orderDate = new Date(orderWithId.products[0]?.date).getTime();

    // Verificamos si el pedido tiene una fecha
    if (!orderDate) {
      console.log("No hay fecha en el pedido");
      return;
    }

    // Verificamos si ya hemos procesado un pedido con la misma fecha recientemente
    if (processedOrderDates.has(orderDate)) {
      console.log("Pedido duplicado, no se agrega."); // Muestra mensaje si el pedido ya existe
      return;
    }

    // Si no existe un pedido con la misma fecha, lo agregamos
    setReceiveOrders((prevMessages) => [...prevMessages, { data: orderWithId }]);
    console.log("Pedidos----->", JSON.stringify(orderWithId)); // Muestra el pedido agregado

    // Añadimos la fecha del pedido al mapa
    processedOrderDates.set(orderDate, true);

    // Limpiamos entradas antiguas del mapa después de cierto tiempo (e.g., 5 minutos)
    setTimeout(() => {
      processedOrderDates.delete(orderDate);
    }, 5 * 60 * 1000); // 5 minutos en milisegundos

  } catch (error) {
    console.log("Error:", error); // Manejo del error
  }
};

// traer mensajes desde el chat websocket.io
useEffect(() => {
  socketRef.current = io(api8, { path: "/socket" });

  socketRef.current.on("pedidoALaCocina", handlePedidoALaCocina);

  // Limpieza al desmontar el componente
  return () => {
    if (socketRef.current) {
      socketRef.current.off("pedidoALaCocina");
      socketRef.current.disconnect();
    }
  };
}, []);


  // socketRef, receiveOrders
  useEffect(() => {
    if (!homeVisibility & receiveOrders.length > 0) {
      setNewOrderInProcess(newOrderInProcess + 1)
    }
  }, [receiveOrders])

  // SOUND EFFECTS

  // new order
  useEffect(() => {
if(receiveOrders.length & !chatVisibility > 0){
    const audio = new Audio(soundBoxMoney); // Ruta correcta si el archivo está en la carpeta public
    audio.play().catch(error => {
      setConsoleAdmin(prevState => [...prevState,"Error al reproducir el sonido:", error]);
    });}
  }, [receiveOrders]);

  

  const deleteOrder = (id) => {
    const newOrderArray = receiveOrders.filter((order) => {
      return order.data.id !== (id)
    })
    setReceiveOrders(newOrderArray)
    setDataShow("")
  }

  // GUARDAR PEDIDOS

  const saveRequests = () => {
    const now = new Date();
    setTotalDayObject({ date: now, data: dataOrders, totalPay: payOfDay })



  }



  // LIMPIAR TABLA PEDIDOS

 
  

  const deleteAllPedidos = () => {
  //  setSaveRequestState(saveRequestState + 1)
  saveRequests() 


    fetch(`${api8}/cleanDataBase`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify([]) // Envía una tabla vacía
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Error al limpiar la tabla de órdenes');
        }
        return response.json();
      })
      .then(data => {
        setConsoleAdmin( prevState => [...prevState,'Tabla de órdenes limpiada con éxito', data]);
      })
      .catch(error => {
        setConsoleAdmin(prevState => [...prevState, 'Error al limpiar la tabla de órdenes', error]);
      });
    setDataOrders([])
    setPayOfDay(0)
   
  }
  // funciones visibilidades

  const functionVisibilityHome = () => {
    setHomeVisibility(true)
    setChatVisibility(false)
    setTablesVisibility(false)
    setRegisterVisibility(false)
    setNewOrderInProcess(0)
  }



  const functionVisibilityChat = () => {
    setHomeVisibility(false)
    setChatVisibility(true)
    setTablesVisibility(false)
    setRegisterVisibility(false)
    setNewMessageChat(0)
  }

  const functionVisibilityTables = () => {
    setHomeVisibility(false)
    setChatVisibility(false)
    setTablesVisibility(true)
    setRegisterVisibility(false)
  }

  const functionVisibilityRegister = () => {
    setHomeVisibility(false)
    setChatVisibility(false)
    setTablesVisibility(false)
    setRegisterVisibility(true)
  }


  // LOGICA DEL CHAT

  const [changeForm, setChangeForm] = useState("");

  const [visibilityMessages, setVisibilityMessages] = useState(false)
  const socketRefChat = useRef(null);

  // Conexión WebSocket
  useEffect(() => {

    socketRefChat.current = io(api8, {
      path: "/socket",
      transports: ['websocket', 'polling'],
    });

    socketRefChat.current.on('connect', () => {
      setConsoleAdmin(prevState => [...prevState, "Conectado a WebSocket"]);
    });

    socketRefChat.current.on('connect_error', (error) => {
      setConsoleAdmin(prevState => [...prevState, 'Error al conectar con WebSocket:', error]);
    });

    socketRefChat.current.on('nuevoMensaje', (mensaje) => {
      setConsoleAdmin(prevState => [...prevState, 'Nuevo mensaje recibido:', mensaje]);
      setMensajes((prevMensajes) => [...prevMensajes, mensaje]);

      setVisibilityMessages(true)
    });

    return () => {
      socketRefChat.current.disconnect();
    };
  }, []);

  useEffect(() => {
    if (!chatVisibility & mensajes.length > 0) {
      setNewMessageChat(newMessageChat + 1)
    }
  }, [mensajes])

  
  useEffect(() => {

    if(mensajes.length > 0){
        const audio = new Audio(chatSound); // Ruta correcta si el archivo está en la carpeta public
        audio.play().catch(error => {
          setConsoleAdmin( prevState => [...prevState, "Error al reproducir el sonido:", error]);
        });}
      }, [mensajes]);


  // Función para manejar el cambio en el input
  const changeFormFunction = (e) => {
    setChangeForm(e.target.value);
  };

  // Función para manejar el envío del mensaje
  const sendFormFunction = (e) => {
    if(changeForm){
    e.preventDefault();
    const mensaje = {
      text: changeForm,
      timestamp: new Date().toISOString(),
      mesa: "Burger Shop"
    };
    // console.log('Enviando mensaje:', mensaje);
    socketRefChat.current.emit('mensajeChat', mensaje); // Emitir el mensaje al servidor
    setChangeForm(""); // Limpiar el input después de enviar
  }
  else if(!changeForm){
    alert("Escribir el mensaje")
  }
};


useEffect(() => {
  // Accedemos al contenedor de los mensajes
  const chatContainer = document.getElementById('chat-container');
  
  if (chatContainer) {
    // Desplazamos al final del contenedor cada vez que los mensajes cambien
    chatContainer.scrollTop = chatContainer.scrollHeight;
  }
}, [mensajes, chatVisibility]); 

  const chatFunction = () => {

    return (
      <div className="container-chat-admin" id='chat-admin'>
        <form className='form-chat-user' onSubmit={sendFormFunction}>
          <div className='container-impresion-chat' style={{overflowX: "hidden"}}>
            <div   id="chat-container" style={{overflowY: "auto", overflowX: "hidden"}}>
              {mensajes.length > 0 ? (
                mensajes.map((msg, index) => (
                  <div key={index} style={{width: "400px", display: "flex", flexDirection: "column"}}>
                  <div className="container-message-chat"><p> {msg.mesa} dice: </p> <p className="text-chat-admin" style={{ display: "flex", flexDirection: "column"}}>{msg.text} <small>{new Date(msg.timestamp).toLocaleTimeString()}</small></p>
 </div>
 
                 </div>
                ))
              ) : (
                <p>No hay mensajes.</p>
              )}
            </div>
          </div>
          <div className='container-logo-chat'>
            <img className='img-logo-chat' alt="logo" src={imgLogo} />
          </div>
          <div className='container-texarea-user'>
            <textarea
              value={changeForm}
              onChange={changeFormFunction}
              placeholder="Message for the admins."
            />
            <button type="submit"  className='btn-chat-send-2'>Enviar</button>
          </div>
        </form>
      </div>
    );

  }



  // LOGICA PARA ELIMINAR REGISTRO DE BD DEL DIA


  // aumento de rendimiento (no esta en uso)

  const deleteRegister = (id) => {

    const newArray = dataOrders.filter((data) => {
return data.id !== id
    })

    setDataOrders(newArray)
  }

  const [newSoundEffect, setNewSoundEffect] = useState(0)


  // waiter
  useEffect(() => {
    // const audioUbication = './../../sounds/Cash_Register_Kashing_-_Sound_Effect_[_YouConvert.net_].mp3'
   
  
    // if(tablesVisibility === false){
        const audio = new Audio(soundCampaignMoney); // Ruta correcta si el archivo está en la carpeta public
        audio.play().catch(error => {
          setConsoleAdmin(prevState => [...prevState, "Error al reproducir el sonido:", error]);
        });
      // }
      }, [newSoundEffect]);
  



// LOGICA PARA DESCONECCION DE CADA DISPOSITIVO

      const handleClienteDesconectado = useCallback((tableNumber) => {
        setConsoleAdmin(prevState => [...prevState, 'Cliente desconectado: ', tableNumber]);
        
        const numberTable = String(tableNumber);  // Asegúrate de que esto sea necesario y no se pueda evitar.
      
        setTablesArray(prevState => {
          const tableIndex = prevState.findIndex(table => table.tableNumber === numberTable);
          
          // Si la mesa no existe, retornamos el estado previo
          if (tableIndex === -1) {
            setConsoleAdmin(prevState => [...prevState, 'Error la mesa no existe en el array, no se hará ningún cambio']);
            return prevState;
          }
      
          const table = prevState[tableIndex];
      
          // Si la mesa tiene más de una conexión, decrementamos el contador
          if (table.numberConects > 1) {
            setConsoleAdmin(prevState => [...prevState,'Decrementando número de conexiones']);
            const updatedTables = [...prevState];
            updatedTables[tableIndex] = { ...table, numberConects: table.numberConects - 1 };
            return updatedTables;
          } else if (table.numberConects === 1) {
            setConsoleAdmin(prevState => [...prevState, 'Eliminando mesa del array']);
            return prevState.filter(t => t.tableNumber !== numberTable);
          }
      
          return prevState;  // Si no se cumple ninguna de las condiciones, retornamos el estado sin cambios.
        });
      
        setConsoleAdmin(prevState => [...prevState, "Mesa desconectada número " + tableNumber]);
      }, []);



  // LOGICA mesas

const [newRequestWaiter, setNewRequestWaiter] = useState(0)
const [tablesArray, setTablesArray] = useState([])
const [intervalState, setIntervalState] = useState([]) 
const [newRequest, setNewRequest] = useState(0)

  
useEffect(() => {
    socketRef.current = io(api8, {
      path: '/socket',
      transports: ['websocket', 'polling'],
    
    
    });

    socketRef.current.on('enviar_mesa_admin', (tableNumber) => {
      // Verificar si la mesa ya está en el array usando el estado más reciente
      setTablesArray(prevState => {
        const tableExists = prevState.some(table => table.tableNumber === tableNumber);
    
        if (!tableExists) {
          // Si la mesa no está en el array, agregarla
          return [
            ...prevState,
            { tableNumber: tableNumber, StateVisibility: false, numberConects: 1 }
          ];
        } else {
          // Si la mesa ya existe, incrementar `numberConects`
          return prevState.map(table =>
            table.tableNumber === tableNumber
              ? { ...table, numberConects: table.numberConects + 1 }
              : table
          );
        }
      });
    
      setConsoleAdmin(prevState => [...prevState, "Recibida la mesa número " + tableNumber]);
    });
    




  socketRef.current.on('solicitar_mesero', (tableNumber) => {
setNewRequestWaiter(newRequestWaiter + 1)

    setTablesArray(prevState => 
      prevState.map(table => 
        table.tableNumber === tableNumber
          ? { ...table, StateVisibility: true }  // Activar visibilidad del botón
          : table
      )
    );
    setNewSoundEffect(newSoundEffect + 1)
  });

   
socketRef.current.on("cliente_desconectado", handleClienteDesconectado)


    // Limpiar los eventos al desmontar
    return () => {
      socketRef.current.off('solicitar_mesero');
socketRef.current.off("cliente_desconectado")
      socketRef.current.off('enviar_mesa_admin');
    };
  }, []);
  
const functionDataShow = () => {

  if (!dataShow) return null;  // Asegurarse de que dataShow esté disponible

  // Extraer los productos de la orden
  const totalProduc = dataShow.products.map((product) => product);


  // RETURN CENTRAL DEL COMPONENTE

  return (
    <div className="impresion-websocket-container">
      <div>
        <button  onClick={(e) => {
          e.preventDefault()
          setVisibilityDetails(false)
        }}>X</button>
      </div>
      
      <h1>Mesa: {dataShow.table}</h1>
      <h2>Total a Pagar: {(dataShow.totalPayOrder * 1.19).toFixed(2)}</h2>
      <h3>Id: {dataShow.id}</h3>

      {/* Aquí asumo que totalProduc es un array definido previamente */}
      <h2>Abreviacion: 
        <ul>
          {totalProduc.map((product, index) => (
            <li key={index}>{product.name}
            {product.forHome && <img src={imgForHome} style={{marginLeft: "1px"}} className="icon-home-admin" />}
            </li>
          ))}
        </ul>
      </h2>

      <h3>Orden:</h3>
      {dataShow.products.map((product, productIndex) => (
        <div key={productIndex}>
          <h4>Nombre: {product.name}</h4>
          <p>Kcal: {product.kcal}</p>
          <p>Precio: {product.price}</p>
          <p>Fecha: {product.date}</p>
          <p>Ingredientes: {product.ingredients}</p>
        </div>
      ))}
    </div>
  );
};

const [visibilityDetails, setVisibilityDetails] = useState(false)
  // Función para alternar la visibilidad de la orden
  const toggleVisibility = (data) => {
    
    setDataShow(data);
    setVisibilityDetails(true)
  }; 


  // CONSOLA DEL ADMINISTRADOR

  const functionConsole = () => {

    return(
      <div className="console-container">
        <ul className="list-console">
          {consoleAdmin.map((data, index) => {
            return (
              <li key={index} className="date-console">{data}</li>
            )
          }
          )}
        </ul>
      </div>
    )
  }


// FUNCIONES PARA GENERAR FACTURA

// FUNCION PARA GENERAR FACTURA IMPRESORA INDUSTRIAL O DE RESTAURANTE
// const facturaFunction = (id, totalPay, product) => {
//   const ivaTipo = 0.21; // IVA al 21% (por defecto)
//   const iva = totalPay * ivaTipo;
//   const baseImponible = totalPay; // El total sin IVA
  
//   // Crear la cadena de texto de la factura
//   const fecha = new Date().toLocaleDateString('es-ES');  // Formato dd/mm/yyyy en España
//   const numeroFactura = generateUniqueId(); // Se debe generar un número de factura único

//   const facturaText = `
//     FACTURA DE VENTA
//     EMISOR:
//     Razón Social: Burger-Shop
//     NIF: B12345678
//     Dirección: Avenida Siempreviva 123, Madrid, España
//     Teléfono: 233534
//     Email: blablalb@blabla.com

//     COMPRADOR:
//     Cliente: ${id}
//     NIF/NIE: No identificado
//     Dirección: null
//     Teléfono: null

//     DETALLES DE LA FACTURA:
//     Fecha: ${fecha}, Número de factura: ${numeroFactura}

//     Productos:
//     ${product.map((product, index) => `
//       ${index + 1}. ${product.name} - ${product.price} €
//     `).join('\n')}
    
//     Subtotal (sin IVA): ${baseImponible} €
//     IVA (${ivaTipo * 100}%): ${iva} €
//     Total a pagar (IVA incluido): ${totalPay + iva} €
//   `;
  
//   return facturaText;
// };

// // FUNCION PARA IMPRIMIR LA FACTURA
// const imprimirFactura = async (id, totalToPay, products) => {
//   const device = await navigator.usb.requestDevice({
//     filters: [{ vendorId: 0x1234 }] // Asegúrate de reemplazar con el ID correcto de tu impresora
//   });

//   await device.open();
//   await device.selectConfiguration(1);
//   await device.claimInterface(0);

//   const facturaText = facturaFunction(id, totalToPay, products);

//   // Convertir el texto de la factura en bytes
//   const encoder = new TextEncoder();
//   const data = encoder.encode(facturaText);

//   // Comandos ESC/POS para la impresora térmica
//   const escPosCommands = [
//     new Uint8Array([0x1B, 0x40]), // Inicializar la impresora
//     new Uint8Array([0x1B, 0x61, 0x01]), // Alinear texto al centro
//     data, // Factura
//     new Uint8Array([0x1D, 0x56, 0x00]), // Cortar el papel (depende de la impresora)
//   ];

//   // Enviar los comandos ESC/POS
//   for (const command of escPosCommands) {
//     await device.transferOut(1, command);
//   }

//   await device.close();
// };


// FACTURA PRA CUALQUIER TIPO DE IMPRESORA



const imprimirFacturaMixta = (id, totalToPay, products) => {
  const ivaTipo = 1.19; // IVA al 21% (por defecto)
  const iva = totalToPay * ivaTipo;
  const baseImponible = totalToPay; // El total sin IVA

  // Crear el texto de la factura
  const fecha = new Date().toLocaleDateString('es-ES');
  const numeroFactura = generateUniqueId(); // Generar un número de factura único

  // Crear un documento PDF usando jsPDF con tamaño de página más ajustado
  const doc = new jsPDF({
    unit: 'mm',
    format: [58, 250],  // Reducción a 58mm de ancho y 250mm de largo (más pequeño)
  });

  // Ajustes para que el texto no se desborde en un tamaño más pequeño
  const pageWidth = 58; // 58mm para impresoras térmicas
  const margin = 3;
  const margintop = 5;
  const lineHeight = 4; // Reducir la altura de línea para adaptarse mejor
  const startX = margin;
  const startY = margintop;

  // Fuente del texto: reducir tamaño de fuente para que se ajuste al ancho más pequeño
  doc.setFont("helvetica", "normal");
  doc.setFontSize(6); // Reducir el tamaño de la fuente

  // Escribir la cabecera
  doc.setFontSize(8);
  doc.setFont("helvetica", "bold");
  doc.text("FACTURA DE VENTA", startX, startY);
  doc.setFontSize(6);
  doc.setFont("helvetica", "normal");

  // Información del EMISOR
  doc.text("EMISOR:", startX, startY + lineHeight);
  doc.setFont("helvetica", "bold");
  doc.text("Razón Social: Burger-Shop", startX, startY + 2 * lineHeight);
  doc.setFont("helvetica", "normal");
  doc.text("NIF: EIN B12345678", startX, startY + 3 * lineHeight);
  doc.text("Dirección: Avenida Siempreviva 123, Madrid, España", startX, startY + 4 * lineHeight);
  doc.text("Teléfono: 233534", startX, startY + 5 * lineHeight);
  doc.text("Email: blablalb@blabla.com", startX, startY + 6 * lineHeight);

  // Línea separadora
  doc.setLineWidth(0.1);
  doc.line(startX, startY + 7 * lineHeight, pageWidth - margin, startY + 7 * lineHeight);

  // Información del COMPRADOR
  doc.setFont("helvetica", "bold");
  doc.text("COMPRADOR:", startX, startY + 8 * lineHeight);
  doc.setFont("helvetica", "normal");
  doc.text(`Cliente: ${id}`, startX, startY + 9 * lineHeight);
  doc.text("EIN: No identificado", startX, startY + 10 * lineHeight);
 
  // Línea separadora
  doc.line(startX, startY + 13 * lineHeight, pageWidth - margin, startY + 13 * lineHeight);

  // Detalles de la factura
  doc.setFont("helvetica", "bold");
  doc.text("DETALLES DE LA FACTURA:", startX, startY + 14 * lineHeight);
  doc.setFont("helvetica", "normal");
  doc.text(`Fecha: ${fecha}`, startX, startY + 15 * lineHeight);
  doc.text(`Número de factura: ${numeroFactura}`, startX, startY + 16 * lineHeight);

  // Línea separadora
  doc.line(startX, startY + 17 * lineHeight, pageWidth - margin, startY + 17 * lineHeight);

  // Ajustar los productos
  doc.setFont("helvetica", "bold");
  doc.text("Productos:", startX, startY + 18 * lineHeight);
  doc.setFont("helvetica", "normal");

  let currentY = startY + 19 * lineHeight;

  products.forEach((product, index) => {
    let productText = `${index + 1}. ${product.name} - ${product.price} €`;
    if (doc.getTextWidth(productText) > pageWidth - 2 * margin) {
      productText = productText.substring(0, 30) + '...'; // Limitar el nombre del producto si es largo
    }
    doc.text(productText, startX, currentY);
    currentY += lineHeight;
  });

  // Línea separadora
  doc.line(startX, currentY, pageWidth - margin, currentY);

  // Totales
  doc.setFont("helvetica", "bold");
  doc.text(`Subtotal (sin IVA): ${baseImponible} $`, startX, currentY + 3 * lineHeight);
  doc.text(`IVA (21%): ${iva} $`, startX, currentY + 4 * lineHeight);
  doc.text(`Total a pagar (IVA incluido): ${(iva).toFixed(2)} $`, startX, currentY + 5 * lineHeight);

  // Línea final
  doc.line(startX, currentY + 6 * lineHeight, pageWidth - margin, currentY + 6 * lineHeight);

  // Guardar el archivo PDF
  doc.save('factura.pdf');
};


// LOGICA IP

const [adminIp, setAdminIp ] = useState("")

useEffect(() => {
fetch('https://api.ipify.org?format=json').then(res => res.json()).then(data => setAdminIp(data.ip))
}, [])

const nombreRestaurante = 'Burger shop'

// Función para obtener la IP pública
const functionPutIp = () => {
  const config = {
    method: "POST",
    headers: {
      'Content-Type': 'application/json', // Corrección aquí
    },
    body: JSON.stringify({ // Convertir el objeto a JSON
      ip: adminIp,
      nameRestaurant: nombreRestaurante
    })
  };

  fetch(`${centralApi}/postNewIp`, config)
    .then(response => response.json()) // Convertir la respuesta en JSON
    .then(data => {
      console.log("Respuesta del servidor:", data);
      alert("ip actualizada correctamente.")
    })
    .catch(error => {
      console.error("Error en la solicitud:", error);
    });
};
const [stateSendComment, setStateSendComment] = useState(true);
const [comment, setComment] = useState("");

const closeStateSend = () => {
  setStateSendComment(false);
};

const captureChangeState = (e) => {
  setComment(e.target.value);
};


  const sendComment = async () => {
    
    try {
      const response = await fetch(`${centralApi}/ComentsUsers`, {
        method: 'POST', // Establece el método como POST
        headers: {
          'Content-Type': 'application/json', // Especifica que estamos enviando datos JSON
        },
        body: JSON.stringify({
          date : new Date().toString(),
          comment: comment
        }), // Convierte el objeto de datos a JSON
      });
  
      if (!response.ok) {
        throw new Error('Error al enviar el comentario');
      }
  
      const data = await response.json(); // Procesa la respuesta JSON
      console.log('Comentario enviado:', data);
   
      return data;
    } catch (error) {
      console.error('Error:', error);
      return null;
    }
  };
  
  // Ejemplo de uso
  
  const submitComment = (e) => {
    e.preventDefault()
    sendComment()
    setStateSendComment(false)
    alert("Comentario enviado con exito.")
  }
 

const stateComment = () => {
  return (
    <div className="stateSendComment">
      <div className="container-statesendcomment">
        {/* Botón para cerrar el comentario */}
        <button className="primary-button" onClick={() => closeStateSend()}>
          x
        </button>
      </div>

      <div className="sendcomment">
        <p className="p-sendcomment">¿Tienes alguna sugerencia?</p>
        <input
          className="input-sendcomment"
          onChange={captureChangeState}
          value={comment} // Esto hace que el input sea controlado
        />
        <p>Tu opinión es muy importante para nosotros.</p>
      </div>
<div>
  <button className="primary-button" onClick={(e) => submitComment(e)}>Enviar</button>
</div>
    </div>
  );
};


  // RETURN PRINCIPAL COMPONENTE
  return (
   securityAdmin ? ( <div className="container-admin">
    {stateSendComment && stateComment()}
      <div className="container-logo-macdonalds-admin">
        <img src={mcDonaldsLogo} className="img-logo-macdonalds-admin" />
        <h1>Administrador</h1>



        <nav className="barnav-admin">
          <button id="btn-number" style={{ display: "flex", flexDirection: "row" }} onClick={() => functionVisibilityHome()}>INICIO <p style={{
        marginLeft: '5px',
        backgroundColor: 'red',
        color: 'white',
        borderRadius: '50%',
        padding: '2px 8px',
        fontSize: '12px',
        fontWeight: 'bold',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '20px',
        minHeight: '20px',
        textAlign: 'center',
        lineHeight: '1'
      }}>
        {newOrderInProcess}
      </p></button>
          <button disabled={freeVersion} id="btn-number" style={{ display: "flex", flexDirection: "row" }} onClick={() => functionVisibilityTables()}>MESAS <p style={{
        marginLeft: '5px',
        backgroundColor: 'red',
        color: 'white',
        borderRadius: '50%',
        padding: '2px 8px',
        fontSize: '12px',
        fontWeight: 'bold',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '20px',
        minHeight: '20px',
        textAlign: 'center',
        lineHeight: '1'
      }}>
        {newRequestWaiter}
      </p></button>
          <button  id="btn-number" style={{ display: "flex", flexDirection: "row" }} onClick={() => functionVisibilityChat()}><p style={{marginLeft: "4px"}}>CHAT</p>     <p style={{
        marginLeft: '5px',
        backgroundColor: 'red',
        color: 'white',
        borderRadius: '50%',
        padding: '2px 8px',
        fontSize: '12px',
        fontWeight: 'bold',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '20px',
        minHeight: '20px',
        textAlign: 'center',
        lineHeight: '1'
      }}>
        {newMessageChat}
      </p></button>
          <button disabled={freeVersion} onClick={() => functionVisibilityRegister()}>REGISTRO</button>
        </nav>

        {
          tablesVisibility && <React.Fragment>
            <Tables setConsoleAdmin={setConsoleAdmin} consoleAdmin={consoleAdmin} setNewRequestWaiter={setNewRequestWaiter} newRequestWaiter={newRequestWaiter} tablesArray={tablesArray} setTablesArray={setTablesArray} receiveOrders={receiveOrders} setReceiveOrders={setReceiveOrders} />
          </React.Fragment>
        }

        {
          registerVisibility && <React.Fragment>
            <Register newFetch={newFetch} setNewFetch={setNewFetch} consoleAdmin={consoleAdmin} setConsoleAdmin={setConsoleAdmin} dataOrders={dataOrders} />
          </React.Fragment>
        }

        {
          chatVisibility && <div>
            {chatFunction()}
          </div>
        }

        {
          homeVisibility && <div className="container-mapeo-bd">
            {functionMapeoBaseDeDatos()}
        
            <div style={{display: "flex", flexDirection: "row"}}>
              {visibilityPayOfDay && <h1 className="ganancy-h">GANANCIAS DEL DIA: <span style={{color: "white"}}>{payOfDay}</span></h1>}
              <button id="btn-save" disabled={freeVersion} className='btn-chat-send-2' onClick={deleteAllPedidos} style={{position: "absolute", top: "102%", left: "70%"}}>GUARDAR</button>
        
            </div>
          </div>
        }

      </div>
      {homeVisibility &&
        <div className="admin-carbuy-central-orders">
 {/* {consoleAdmin.length > 0 && functionConsole()} */}
          <h1>Órdenes En Curso</h1>
          <button className="primary-button" style={{marginTop: "10px", marginBottom: "10px"}} onClick={() => functionPutIp()}>Actualizar Ip</button>
          {receiveOrders.map((orderData) => {
            const { data } = orderData;
            const { id, table, products, totalPayOrder } = data;
            const isCompleted = completedOrders.has(id);
            const isVisible = orderVisibility[id];
            const hour = new Date()
            const includeForHome = products.some(order => order.forHome === true)
            // const totalProduc = dataShow.products.map((product) => product.name);
            // const productNamesString = totalProduc.join(", ");
          //  console.log("!!!!esta es la estructura de DATA" + JSON.stringify(data))
            return (
              <div key={id} className="container-impresion-orders" >
                <button onClick={() => toggleVisibility(data)} className={`order-item ${isCompleted ? 'active' : ''}`}>
                  Orden mesa: {table}<br /> hora: {products[0].date}{ includeForHome && <div className="container-home-icon"><img src={imgForHome} className="icon-home-admin-screen" /></div>} 
                </button>
                <div className="container-buttons-orders">
                <button onClick={() => imprimirFacturaMixta(id, totalPayOrder, products)}>Facturar</button>
                <button onClick={() => completeOrder(id, table)}>Revisado</button>
                <button onClick={() => deleteOrder(id)}>X</button>
</div>
                {visibilityDetails && functionDataShow()}
              
              </div>
            );
          })}
        </div>
      }


    </div>
  ): <Error setVisibilityClientFrontend={setVisibilityClientFrontend} />);
}



export default Admin8